module.exports = __webpack_public_path__ + "img/w3_chevron_down_red.755a1f81.png";